"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatisticTypeLabel = exports.StatisticType = exports.Coordinates2D = void 0;
var Coordinates2D;
(function (Coordinates2D) {
    Coordinates2D["x"] = "x";
    Coordinates2D["y"] = "y";
})(Coordinates2D || (exports.Coordinates2D = Coordinates2D = {}));
var StatisticType;
(function (StatisticType) {
    StatisticType["BOOLEAN"] = "boolean";
    StatisticType["COUNT"] = "count";
    StatisticType["PIE"] = "pie";
    StatisticType["SCATTER_PLOT"] = "scatterPlot";
    StatisticType["VALUE"] = "value";
})(StatisticType || (exports.StatisticType = StatisticType = {}));
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var getStatisticTypeLabel = function (type) {
    switch (type) {
        case StatisticType.BOOLEAN:
            return 'Oui / Non';
        case StatisticType.COUNT:
            return 'Dénombrement';
        case StatisticType.PIE:
            return 'Camembert';
        case StatisticType.SCATTER_PLOT:
            return 'Nuage de points';
        case StatisticType.VALUE:
            return 'Valeur';
        default:
            return 'Inconnu';
    }
};
exports.getStatisticTypeLabel = getStatisticTypeLabel;
//# sourceMappingURL=statistics.js.map